import React, { Component } from 'react'
import withStyles from '@material-ui/core/styles/withStyles';
import { List, CircularProgress, ListItem, ListItemAvatar, Avatar, ListItemText, Switch } from '@material-ui/core';

import { authMiddleWare } from '../../util/auth';
import functionsApi from '../../api';
import { getPaypalValue } from '../../util/trainersHelper';
//import {getPaypalValue} from '../../account';

const styles = (theme) => ({
    content: {
        width: '100%',
        flexGrow: 1,
        padding: theme.spacing(3),
    },
    toolbar: theme.mixins.toolbar,
    uiProgess: {
		position: 'fixed',
		zIndex: '1000',
		height: '31px',
		width: '31px',
		left: '50%',
		top: '35%'
    },
    root: {
        width: '100%',
    },
    switchContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '50px',
    },
    listItem: {
        padding: 10,
        margin: 10,
        backgroundColor: theme.palette.background.paper,
    }
})

class allTrainersList extends Component {

    constructor(props) {
		super(props);

		this.state = {
			trainers: [],
			uiLoading: true,
		};
	}

    componentWillMount = () => {
		authMiddleWare(this.props.history);
        this.reloadPage()
    };

    reloadPage = () => {
		functionsApi
			.get('/getAllTrainers')
			.then((response) => {
				this.setState({
					trainers: response.data,
					uiLoading: false
				});
			})
			.catch((err) => {
                console.error(err);
                this.setState({
                    loading: false
                });
			});
    };

    toggleChecked(trainer) {

        authMiddleWare(this.props.history);
        
        const formRequest = {
            id: trainer.id,
			isActive: !trainer.isActive
        };
        
        functionsApi
			.post('/activateTrainer', formRequest)
			.then((trainer) => {
                this.reloadPage();
				this.setState({ loading: false });
			})
			.catch((error) => {
                this.props.history.push('/login');
				this.setState({
					loading: false
				});
			});
    };
    
    renderTrainer() {
        const { classes } = this.props;
        return this.state.trainers.map((trainer, i) => (
            <ListItem alignItems="flex-start" className={classes.listItem} key={i}>
                <ListItemAvatar>
                <Avatar alt={trainer.name} src={trainer.url} />
                </ListItemAvatar>
                <ListItemText
                primary={trainer.name}
                secondary={trainer.email + " | " + trainer.certification + " | " + "PayPal: " + getPaypalValue(trainer) }           
                />
                <div className={classes.switchContainer}>
                    <Switch size="small" checked={trainer.isActive} onChange={() => this.toggleChecked(trainer) } />
                </div> 
            </ListItem>
        ));
    };

    render() {
        const { classes } = this.props;

        if (this.state.uiLoading === true) {
			return (
				<main className={classes.content}>
					<div className={classes.toolbar} />
					{this.state.uiLoading && <CircularProgress className={classes.uiProgess} />}
				</main>
			);
		} else {
			return (
                <main className={classes.content}>
					<div className={classes.toolbar} />
                    <List dense className={classes.root}>
                        { this.renderTrainer() }
                    </List>
                </main>
            );
        }
    }
}

export default withStyles(styles)(allTrainersList);